import React, { useState, useEffect } from "react"

import {
  Card,
  CardHeader,
  IconButton,
  Stack,
  CardContent,
  Fab,
} from "@mui/material"
import api from "../../../../services/ResApi"
import { FetchErrorHandeling } from "../../../../errorHandeling/FetchErrorHandeling"
import Alerts from "../../../../errorHandeling/Alerts"
import CreateNewTerminalModal from "./CreateNewTerminalModal"
import AddIcon from "@mui/icons-material/Add"
import DeleteForeverIcon from "@mui/icons-material/DeleteForever"
import DeleteModal from "../../../../../toms/components/DeleteModals/DeleteModal"
import { RequestErrorHandeling } from "../../../../errorHandeling/RequestErrorHandeling"

const TerminalModalSetup = () => {
  const [TerminalModalData, setTerminalModalData] = useState([])
  const [editingData, setEditingData] = useState()

  const [isDataChanged, setIsDataChanged] = useState(false)

  const [editModalOpen, setEditModalOpen] = useState(false)

  //for success messages
  const [isSuccess, setIsSuccess] = useState(false)
  const [successMessages, setSuccessMessages] = useState([])

  //for error handling
  const [iserror, setIserror] = useState(false)
  const [iserrorShow, setIserrorShow] = useState(false)
  const [errorMessages, setErrorMessages] = useState([])

  const [deleteModalOpen, setDeleteModalOpen] = useState(false)
  const [isDltBtnLoading, setIsDltBtnLoading] = useState(false)
  const [trmnlMdlName, setTrmnlMdlName] = useState()

  //clear all alerts after a timeout
  useEffect(() => {
    if ((iserror || isSuccess) === true) {
      let timerId = setTimeout(() => {
        setSuccessMessages([])
        setIsSuccess(false)
        setIserror(false)
        setErrorMessages([])
        timerId = null
      }, 5000)
      return () => clearTimeout(timerId)
    }
  }, [iserror, isSuccess])

  useEffect(() => {
    const config = {
      headers: {
        Action: "ALL_MODELS",
      },
    }
    api
      .get("/terminal/models", config)
      .then((res) => {
        setTerminalModalData(res.data?.dataList)
        setIsDataChanged(false)

        setErrorMessages([])
        setIserror(false)
      })
      .catch((error) => {
        FetchErrorHandeling(error, setIserror, setErrorMessages, setIserrorShow)
      })
  }, [isDataChanged])

  const handleDelete = () => {
    const dltConfig = {
      headers: {
        "Terminal-Model": trmnlMdlName,
      },
    }
    setIsDltBtnLoading(true)
    api
      .delete("/terminal/models", dltConfig)
      .then((res) => {
        setIsDltBtnLoading(false)
        setIsDataChanged(true)
        setIsSuccess(true)
        setSuccessMessages([res.data?.description])
        setDeleteModalOpen(false)
      })
      .catch((err) => {
        setIsDltBtnLoading(false)
        setDeleteModalOpen(false)
        RequestErrorHandeling(err, setIserror, setErrorMessages, setIserrorShow)
      })
  }

  return (
    <div>
      <div>
        <Alerts
          iserror={iserror}
          errorMessages={errorMessages}
          iserrorShow={iserrorShow}
          isSuccess={isSuccess}
          successMessages={successMessages}
        />
      </div>
      <Fab
        onClick={() => setEditModalOpen(true)}
        color="success"
        variant="extended"
        sx={{ position: "absolute", right: 25 }}
      >
        <AddIcon sx={{ mr: 1 }} />
        Create new
      </Fab>
      <Stack
        spacing={{ xs: 1, sm: 2 }}
        direction="row"
        useFlexGap
        sx={{ flexWrap: "wrap", mt: 10 }}
      >
        {TerminalModalData?.map((terminal) => (
          <Card
            sx={{
              maxWidth: 385,
              width: 350,
              height: 200,
              boxShadow: 3,
              borderRadius: "10px",
              position: "relative",
            }}
          >
            <CardHeader
              className="userPermissionCardHeader"
              title={<h5>{terminal.model}</h5>}
              action={
                <div>
                  <IconButton
                    aria-label="delete"
                    onClick={() => {
                      setTrmnlMdlName(terminal.model)
                      setDeleteModalOpen(true)
                    }}
                  >
                    <DeleteForeverIcon color="error" />
                  </IconButton>
                </div>
              }
            />
            <CardContent
              sx={{
                maxHeight: 200,
                overflowY: "auto",
              }}
            >
              <p>
                <strong>Description:</strong> {terminal?.description}
              </p>
            </CardContent>
          </Card>
        ))}
      </Stack>
      <CreateNewTerminalModal
        editingData={editingData}
        open={editModalOpen}
        onClose={() => setEditModalOpen(false)}
        setIsDataChanged={setIsDataChanged}
      />
      <DeleteModal
        open={deleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
        onDelete={handleDelete}
        isBtnLoading={isDltBtnLoading}
      />
    </div>
  )
}

export default TerminalModalSetup
